// extracted by mini-css-extract-plugin
export var orderDetails = "_vd-2";
export var orderImage = "_vd-1";
export var orderMeta = "_vd-3";
export var orderSummary = "_vd-0";
export var rightArrow = "_vd-4";